/**
 * @desc: 消息组件
 * */
import React from 'react';
import ReactDOM from 'react-dom';
import './message.scss';
import './mobile-message.scss';
import classNames from 'classnames';
import PreviewModal from '@/components/preview_modal/preview_modal';
import SingleMessage from './singleMessage/singleMessage';
import {postMessageData, request, ApiUri} from '@/helper';
import { getToken } from '@/lib/fetch';

export default class MobileMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      audioUrl: '',
      playingMessageId: ''
    };
    this.previewDiv = null;
  }
  render() {
    const { online, messages, $updateMessage } = this.props;
    return (
      <React.Fragment>
        <div className='ms-wrapper'>
          <div id='mobile-ms-wrapper'>
            <div className="ms-container" ref="triggerNode">
              {
                messages
                  ? messages.map((message, index) => {
                    const fileLength = message.fileLength || message.file_length;
                    const style = {
                      width: `${message && fileLength * 10 + 40}px`
                    };
                    let robotAvatar = false;
                    if (message.message_type === 'system' && !message.fromMe) {
                      message.avatar = 'https://m.xiguacity.cn/avatar/head.png';
                      robotAvatar = true;
                    }
                    return (
                      <div
                        className={message.fromMe ? 'ms-item right' : 'ms-item left'}
                        key={index}>
                        <div className={online ? 'ms-avatar' : (robotAvatar ? 'ms-avatar' : 'ms-avatar offline')}>
                          <img src={message.avatar} alt=""/>
                        </div>
                        <div
                          className={message.fromMe ? 'ms-content right' : 'ms-content left'}>
                          <SingleMessage audioSrc={this.props.audioSrc} data={this.props.data} message={message} style={style} $updateMessage={$updateMessage}/>
                        </div>
                      </div>
                    );
                  })
                  : null
              }
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
  componentDidMount() {
    let msContainer = document.querySelector('.ms-container');
    msContainer.addEventListener('click', (e) => {
      e.preventDefault();
      let tagName = e.target.tagName;
      if (tagName && tagName === 'A') {
        this.openWebPage(e.target.href);
      }
    });
    this.refs.triggerNode.addEventListener('click', e => {
      const questionNode = e.target;
      if (this._isQuestionNode(questionNode)) {
        this.askQuestion(questionNode);
      }
    });
  };

  openWebPage(src) {
    window.bridge && window.bridge.openIMWebPage({
      params: {url: src, showBackBtn: true},
      success: () => {},
      fail: () => {}
    });
  }
  removeModal() {
    ReactDOM.unmountComponentAtNode(this.previewDiv);
    document.body.removeChild(this.previewDiv);
  }
  // 获取答案
  askQuestion(node) {
    const { data, $updateMessage } = this.props;
    let lectureId = data && data.lectureId;
    lectureId = lectureId || node.getAttribute('data-lectureid');
    this.ajaxObtainAnswer({
      message_text: node.getAttribute('data-text'),
      message_image: `![image](${node.getAttribute('data-image')})`,
      has_ticket: data && data.hasTicket,
      last_message_course_id: '',
      last_message_package_id: '',
      lecture_id: lectureId,
      message_tag: node.getAttribute('data-tag'),
      message_template_item_id: node.getAttribute('data-itemid'),
      message: {
        ...postMessageData(data, {})
      }
    }).then(res => {
      res && res.body && res.body.map(message => {
        $updateMessage(message);
      });
    }).catch(e => {
      console.error('网络错误：', e);
    });
  }
  // ajax获取答案
  ajaxObtainAnswer(formData) {
    const { data } = this.props;
    return new Promise((resolve, reject) => {
      request({
        url: ApiUri.OBTAIN_ANSWER,
        method: 'post',
        data: formData,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        headers: {
          'x-csrf-token': data && data.csrf,
          token: getToken(),
        }
      }).then(res => {
        resolve(res);
      }).catch((err, msg) => {
        reject(err, msg);
      });
    });
  }

  // 是否是问题元素节点
  _isQuestionNode(node) {
    return node.getAttribute('data-tag');
  }
}
